import React from 'react';

import {
  NavigationButtonContainer,
  StyledNextBtn
} from './NavigationButtons-styled';

import { CalciteButton } from 'components/Calcite';

type NavigationButtonsProps = {
  onPrevious?: () => void;
  nextLabel?: string;
  nextIsDisabled?: boolean;
  onNext?: () => void;
  nextIsLoading?: boolean;
};

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onPrevious,
  nextLabel = 'Next',
  nextIsDisabled = false,
  onNext,
  nextIsLoading = false
}: NavigationButtonsProps) => {
  const renderPrevButton = () => {
    return onPrevious ? (
      <CalciteButton appearance="outline" onClick={onPrevious}>
        Previous
      </CalciteButton>
    ) : null;
  };

  const renderNextButton = () => {
    return onNext ? (
      <StyledNextBtn
        disabled={nextIsDisabled || nextIsLoading}
        loading={nextIsLoading}
        onClick={onNext}
      >
        {nextLabel}
      </StyledNextBtn>
    ) : null;
  };

  return (
    <NavigationButtonContainer>
      {renderPrevButton()}
      {renderNextButton()}
    </NavigationButtonContainer>
  );
};

export default NavigationButtons;
